/* eslint-disable react/no-array-index-key,no-useless-constructor */
import React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import config from '../../../config';
import pages from '../../../constants/admin-pages';
import RoleView from '../../RoleView';
import i18n from "i18next";
import { withNamespaces } from 'react-i18next';
import {Button} from "react-bootstrap";
import "./index.css"
import gallerySVG from "../../../asset/img/gallery.svg";
import OAuth2 from "../../../constants/OAuth2";

const SideBarItem = ({ page, activePath }) => {
  if (activePath.startsWith(page.path)) {
    return (
      <li className="active">
        <a>
          <i className={page.icon} />
          <p>
            {i18n.t(page.title)}
          </p>
        </a>
      </li>
    );
  }

  return (
    <li>
      <Link to={activePath.startsWith(page.path) ? '' : page.path}>
        <i className={page.icon} />
        <p>
          {i18n.t(page.title)}
        </p>
      </Link>
    </li>
  );
};

class SideBar extends React.Component {
  constructor(props) {
    super(props);
  }

  getListItems() {
    return pages.map((page, key) => (
      <RoleView key={key} roles={page.roles}>
        <SideBarItem
          key={page.path}
          activePath={this.props.activePath}
          page={page}
        />
      </RoleView>
    ));
  }


  render() {
    const handleButtonClick = () => {
      window.location.href = OAuth2.galleryRedirect;
    };
    return (
      <div
        className="sidebar"
        data-background-color="white"
        data-active-color="danger"
      >
        <div className="sidebar-wrapper">
          <div className="logo">
            <Link to="/requests" className="simple-text">
              {' '}
              {i18n.t(config.app.title)}
            </Link>
          </div>
          <ul className="nav">
            {this.getListItems()}
            <li className="gallery-button">
              <Button className="gallery-ui" onClick={handleButtonClick}>
                <div className="gallery-container">
                  <img src={gallerySVG} className="svg-file"/>
                  <p className="gallery-text">{i18n.t('allApplication')}</p>
                </div>
              </Button>
            </li>
            <li className="active-pro">
              <Link to="/logout">
                <i className="fa fa-sign-out"/>
                <p id="logout">
                  {i18n.t('logout')}
                </p>
              </Link>
            </li>
          </ul>
        </div>
      </div>

    );
  }
}

const mapStateToProps = state => ({
  activePath: state.routing.location.pathname,
  auth: state.auth,
});

export default withNamespaces()(connect(mapStateToProps)(SideBar));



// WEBPACK FOOTER //
// ./src/components/admin/sidebar/index.js